import { render, staticRenderFns } from "./AbschnittSettings.vue?vue&type=template&id=77acf580&"
import script from "./AbschnittSettings.vue?vue&type=script&lang=js&"
export * from "./AbschnittSettings.vue?vue&type=script&lang=js&"
import style0 from "./AbschnittSettings.vue?vue&type=style&index=0&id=77acf580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports